module.exports = __webpack_public_path__ + "static/media/teafloor4.3a76019a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/teafloor4.jpg
// module id = 455
// module chunks = 0